// ============================================================
// Biomixa Theme JS
// ============================================================

// --- Helpers -------------------------------------------------

function getRoot() {
  return (window.ShopifyTheme && window.ShopifyTheme.routes.root) || '/';
}

function formatMoney(cents) {
  var fmt = (window.ShopifyTheme && window.ShopifyTheme.moneyFormat) || '${{amount}}';
  var amount = (cents / 100).toFixed(2);
  return fmt
    .replace('{{amount}}', amount)
    .replace('{{amount_no_decimals}}', String(Math.round(cents / 100)))
    .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
}

function escapeHtml(str) {
  var d = document.createElement('div');
  d.appendChild(document.createTextNode(String(str)));
  return d.innerHTML;
}

// --- Gallery -------------------------------------------------

function switchImg(src, thumb, alt) {
  var mainImg = document.getElementById('gallery-main-img');
  document.querySelectorAll('.gallery-thumb').forEach(function(t) { t.classList.remove('active'); });
  if (thumb) thumb.classList.add('active');
  if (!mainImg || mainImg.dataset.current === src) return;
  mainImg.dataset.current = src;
  var pre = new Image();
  pre.onload = function() {
    mainImg.classList.add('is-fading');
    setTimeout(function() {
      mainImg.removeAttribute('srcset'); mainImg.removeAttribute('sizes');
      mainImg.src = src; if (alt !== undefined) mainImg.alt = alt;
      requestAnimationFrame(function() { mainImg.classList.remove('is-fading'); });
    }, 120);
  };
  pre.src = src;
}

// --- FAQ accordion -------------------------------------------

function toggleFaq(btn) {
  var item = btn.closest('.faq-item');
  var isOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(function(i) {
    i.classList.remove('open');
    var b = i.querySelector('.faq-question'); if (b) b.setAttribute('aria-expanded', 'false');
  });
  if (!isOpen) { item.classList.add('open'); btn.setAttribute('aria-expanded', 'true'); }
}

// --- Cart Drawer ---------------------------------------------

var lastFocused = null;
function openCartDrawer() {
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-overlay');
  if (!drawer) return;
  lastFocused = document.activeElement;
  drawer.classList.add('open');
  drawer.removeAttribute('aria-hidden');
  if (overlay) overlay.classList.add('open');
  document.body.classList.add('cart-drawer-open');
  var closeBtn = document.getElementById('cart-drawer-close');
  if (closeBtn) setTimeout(function() { closeBtn.focus(); }, 50);
  fetchAndRenderCart();
}

function closeCartDrawer() {
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-overlay');
  if (!drawer || !drawer.classList.contains('open')) return;
  drawer.classList.remove('open');
  drawer.setAttribute('aria-hidden', 'true');
  if (overlay) overlay.classList.remove('open');
  document.body.classList.remove('cart-drawer-open');
  if (lastFocused && lastFocused.focus) lastFocused.focus();
}

function fetchAndRenderCart() {
  var itemsEl = document.getElementById('cart-drawer-items');
  if (itemsEl) itemsEl.innerHTML = '<div class="cart-drawer-loading">Loading\u2026</div>';

  fetch(getRoot() + 'cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) { renderCartDrawer(cart); })
    .catch(function() {
      if (itemsEl) itemsEl.innerHTML = '<p class="cart-drawer-error">Could not load cart. Please refresh.</p>';
    });
}

function renderCartDrawer(cart) {
  document.querySelectorAll('.cart-count').forEach(function(el) {
    el.textContent = cart.item_count;
  });
  var countEl = document.getElementById('cart-drawer-count');
  if (countEl) countEl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';

  var itemsEl = document.getElementById('cart-drawer-items');
  var footerEl = document.getElementById('cart-drawer-footer');
  if (!itemsEl) return;

  if (cart.item_count === 0) {
    itemsEl.innerHTML = '<div class="cart-drawer-empty"><p>Your cart is empty.</p><a href="' + getRoot() + '#buy" class="btn-secondary" onclick="closeCartDrawer()">Choose a bundle</a></div>';
    if (footerEl) footerEl.innerHTML = '';
    return;
  }

  itemsEl.innerHTML = cart.items.map(function(item) {
    var imgHtml = item.image
      ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" width="80" height="80" loading="lazy">'
      : '<div class="cart-item-img-placeholder"></div>';
    var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<p class="cart-drawer-item-variant">' + escapeHtml(item.variant_title) + '</p>'
      : '';
    return '<div class="cart-drawer-item" data-key="' + escapeHtml(item.key) + '">'
      + '<div class="cart-drawer-item-img">' + imgHtml + '</div>'
      + '<div class="cart-drawer-item-info">'
      + '<a href="' + escapeHtml(item.url) + '" class="cart-drawer-item-title" onclick="closeCartDrawer()">' + escapeHtml(item.product_title) + '</a>'
      + variantHtml
      + '<div class="cart-drawer-item-row">'
      + '<div class="quantity-selector" style="gap:0;">'
      + '<button type="button" class="qty-btn" onclick="updateCartItem(\'' + escapeHtml(item.key) + '\',' + (item.quantity - 1) + ')" aria-label="Decrease">\u2212</button>'
      + '<input type="number" class="qty-input" value="' + item.quantity + '" min="0" max="99" style="width:42px;" onchange="updateCartItem(\'' + escapeHtml(item.key) + '\',parseInt(this.value)||0)" />'
      + '<button type="button" class="qty-btn" onclick="updateCartItem(\'' + escapeHtml(item.key) + '\',' + (item.quantity + 1) + ')" aria-label="Increase">+</button>'
      + '</div>'
      + '<span class="cart-drawer-item-price">' + formatMoney(item.final_line_price) + '</span>'
      + '</div>'
      + '<button type="button" class="cart-drawer-item-remove" onclick="updateCartItem(\'' + escapeHtml(item.key) + '\',0)">Remove</button>'
      + '</div></div>';
  }).join('');

  if (footerEl) {
    var cartUrl = (window.ShopifyTheme && window.ShopifyTheme.routes.cart_url) || '/cart';
    footerEl.innerHTML = '<div class="cart-drawer-subtotal"><span>Subtotal</span><strong>' + formatMoney(cart.total_price) + '</strong></div>'
      + '<p class="cart-drawer-note">Free U.S. shipping. Taxes calculated at checkout.</p>'
      + '<a href="/checkout" class="btn-buy">Check out</a>'
      + '<a href="' + cartUrl + '" class="btn-secondary">View cart</a>';
  }
}

function updateCartItem(key, quantity) {
  fetch(getRoot() + 'cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
  })
    .then(function(r) { return r.json(); })
    .then(function(cart) { renderCartDrawer(cart); })
    .catch(console.error);
}

// Cart page item update (triggers page reload)
function cartPageUpdateItem(key, quantity) {
  fetch(getRoot() + 'cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
  })
    .then(function(r) { return r.json(); })
    .then(function() { window.location.reload(); })
    .catch(console.error);
}

// --- DOMContentLoaded ----------------------------------------

document.addEventListener('DOMContentLoaded', function() {

  // Drawer close controls
  var closeBtn = document.getElementById('cart-drawer-close');
  var overlay = document.getElementById('cart-overlay');
  if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
  if (overlay) overlay.addEventListener('click', closeCartDrawer);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeCartDrawer();
  });

  // Nav cart icon opens drawer
  var navCart = document.querySelector('a.nav-cart');
  if (navCart) {
    navCart.addEventListener('click', function(e) {
      e.preventDefault();
      openCartDrawer();
    });
  }

  // Load initial cart count
  fetch(getRoot() + 'cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      document.querySelectorAll('.cart-count').forEach(function(el) {
        el.textContent = cart.item_count;
      });
    })
    .catch(function() {});

  // --- Bundle selector + purchase type ------------------------
  function money0(cents) {
    // "$140" instead of "$140.00", keeps cents when needed ("$1.17")
    var str = formatMoney(cents);
    return str.replace(/[.,]00(?=\D*$)/, '');
  }

  var bundleRadios = document.querySelectorAll('input[name="bundle"]');
  var typeRadios = document.querySelectorAll('input[name="purchase-type"]');

  function selectedBundle() {
    var r = document.querySelector('input[name="bundle"]:checked');
    return r || bundleRadios[0] || null;
  }
  function subscribeChosen() {
    var r = document.querySelector('input[name="purchase-type"]:checked');
    return !!(r && r.dataset.sellingPlanId);
  }

  function refreshBuyBox() {
    var b = selectedBundle();
    if (!b) return;
    var price = parseInt(b.dataset.price, 10);
    var compare = parseInt(b.dataset.comparePrice, 10) || 0;
    var jars = parseInt(b.dataset.jars, 10) || 1;
    var subPrice = parseInt(b.dataset.subPrice, 10) || Math.round(price * 0.85);
    var sub = subscribeChosen();
    var payPrice = sub ? subPrice : price;

    var variantInput = document.getElementById('product-variant-id');
    if (variantInput) variantInput.value = b.dataset.variantId;

    var planInput = document.getElementById('selling-plan-input');
    var typeR = document.querySelector('input[name="purchase-type"]:checked');
    if (planInput) planInput.value = (typeR && typeR.dataset.sellingPlanId) || '';

    var set = function(id, text) { var el = document.getElementById(id); if (el) el.textContent = text; };
    set('one-time-price', money0(price));
    set('sub-price-now', money0(subPrice));
    set('sub-price-was', money0(price));
    set('price-current', money0(payPrice));
    set('btn-price', money0(payPrice));
    set('sticky-buy-price', money0(payPrice));
    set('sticky-buy-title', b.dataset.title + (sub ? ' · monthly' : ''));
    set('price-per-serving', formatMoney(Math.round(payPrice / (60 * jars))) + ' per serving');

    var wasEl = document.getElementById('price-original');
    if (wasEl) {
      var wasPrice = sub ? price : compare;
      if (wasPrice > payPrice) { wasEl.textContent = money0(wasPrice); wasEl.hidden = false; }
      else { wasEl.hidden = true; }
    }
    var reassure = document.getElementById('subscribe-reassure');
    if (reassure) reassure.hidden = !sub;

    var btn = document.getElementById('add-to-cart-btn');
    if (btn && b.dataset.available === 'false') { btn.disabled = true; btn.textContent = 'Sold out'; }
  }

  bundleRadios.forEach(function(r) { r.addEventListener('change', refreshBuyBox); });
  typeRadios.forEach(function(r) { r.addEventListener('change', refreshBuyBox); });
  if (bundleRadios.length) refreshBuyBox();

  // --- Sticky mobile buy bar ----------------------------------
  var sticky = document.getElementById('sticky-buy');
  var mainBtn = document.getElementById('add-to-cart-btn');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    var stickyBtn = document.getElementById('sticky-buy-btn');
    if (stickyBtn) stickyBtn.addEventListener('click', function() {
      var f = document.getElementById('product-form');
      if (f) f.requestSubmit ? f.requestSubmit() : f.dispatchEvent(new Event('submit', { cancelable: true }));
    });
    var stickyObs = new IntersectionObserver(function(entries) {
      var e = entries[0];
      var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle('visible', passed);
      sticky.setAttribute('aria-hidden', passed ? 'false' : 'true');
      document.body.classList.toggle('has-sticky-buy', passed);
    }, { threshold: 0 });
    stickyObs.observe(mainBtn);
  }

  // --- Product form: AJAX add to cart -------------------------
  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();

      var btn = document.getElementById('add-to-cart-btn');
      var originalHTML = btn.innerHTML;
      btn.innerHTML = 'Adding\u2026';
      btn.disabled = true;

      var variantId = parseInt(document.getElementById('product-variant-id').value, 10);
      var qtyEl = productForm.querySelector('[name="quantity"]');
      var quantity = parseInt((qtyEl && qtyEl.value) || 1, 10);
      var sellingPlanEl = document.getElementById('selling-plan-input');
      var sellingPlanId = sellingPlanEl && sellingPlanEl.value ? parseInt(sellingPlanEl.value, 10) : null;

      var cartPayload = { id: variantId, quantity: quantity };
      if (sellingPlanId) cartPayload.selling_plan = sellingPlanId;

      fetch(getRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cartPayload)
      })
        .then(function(res) {
          if (!res.ok) return res.json().then(function(err) { return Promise.reject(err); });
          return res.json();
        })
        .then(function() {
          btn.innerHTML = '\u2713 Added!';
          openCartDrawer();
          setTimeout(function() {
            btn.innerHTML = originalHTML;
            btn.disabled = false;
          }, 2000);
        })
        .catch(function(err) {
          var msg = (err && (err.description || err.message)) || 'Could not add to cart.';
          btn.innerHTML = '\u26A0 ' + escapeHtml(msg);
          btn.disabled = false;
          setTimeout(function() { btn.innerHTML = originalHTML; }, 3500);
        });
    });
  }

  // --- Cart page quantity controls ----------------------------
  document.querySelectorAll('.cart-qty-minus, .cart-qty-plus').forEach(function(btn) {
    btn.addEventListener('click', function() {
      cartPageUpdateItem(btn.dataset.itemKey, parseInt(btn.dataset.qty, 10));
    });
  });
  document.querySelectorAll('.cart-item-remove').forEach(function(btn) {
    btn.addEventListener('click', function() {
      cartPageUpdateItem(btn.dataset.itemKey, 0);
    });
  });

  // --- Mobile hamburger ---------------------------------------
  var hamburger = document.querySelector('.nav-hamburger');
  var navLinks = document.querySelector('.nav-links');
  function setMenu(open) {
    if (!hamburger || !navLinks) return;
    navLinks.classList.toggle('open', open);
    hamburger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  if (hamburger) {
    hamburger.addEventListener('click', function() { setMenu(!navLinks.classList.contains('open')); });
    navLinks.addEventListener('click', function(e) { if (e.target.tagName === 'A') setMenu(false); });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') setMenu(false); });
  }

  // --- Gallery thumbs ------------------------------------------
  document.querySelectorAll('.gallery-thumb[data-src]').forEach(function(t) {
    t.addEventListener('click', function() { switchImg(t.dataset.src, t, t.dataset.alt); });
  });

  // --- FAQ ------------------------------------------------------
  document.querySelectorAll('.faq-question').forEach(function(b) {
    b.addEventListener('click', function() { toggleFaq(b); });
  });

});


